import axios from 'axios';
import QS from 'qs';
import router from '../router'
import { Message } from 'element-ui';
// axios.defaults.withCredentials = true;

let http = function() {}

//post请求的请求头
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
//axios request拦截器，目的是为了在请求头上带上token
axios.interceptors.request.use(
    config => {
        if (localStorage.getItem('token')) {
            //token字段是要和后端协商好的
            config.headers.common["Access-Token"] = localStorage.getItem('token');
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    });
// axios response拦截器 判断用户是否登录
axios.interceptors.response.use(
        response => {
            return response;
        },
        error => {
            if (error.response) {
                switch (error.response.status) {
                    case 401:
                        Message.error('请先登录！')
                        router.replace({
                            path: '/login',
                            query: { redirect: router.currentRoute.fullPath,}
                        })
                }
            }
            return Promise.reject(error.response.data)
        }
    )

/**  get方法，对应get请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
http.prototype.get = function(url, params) {
        return new Promise((resolve, reject) => {
            axios.get(url, {
                    params: params
                })
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err.data)
                })
        });
    }
    /** 
     * post方法，对应post请求 
     * @param {String} url [请求的url地址] 
     * @param {Object} params [请求时携带的参数] 
     */
http.prototype.post = function(url, params) {
    return new Promise((resolve, reject) => {
        axios.post(url, QS.stringify(params))
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}

export default new http;


// WEBPACK FOOTER //
// ./src/utils/http.js